<template>
    <div>

        <div class="row">
            <div class="col-md-12 mb10 visible-xs">
                <a class="btn btn-small btn-primary" role="button" href="javascript:void(0);" @click="showFilter = !showFilter">
                    Filters &nbsp;<i :class="['fa fa-chevron-circle-' + (showFilter ? 'up': 'down')]"></i>
                </a>
            </div>
            <div class="col-md-12 mb5" v-show="showFilter">
                <form action="" method="post" autocomplete="off" @submit.prevent="fetchRecord(1)">
                    <div class="row">
                        <!-- Date -->
                        <div class="col-md-3 col-sm-12 form-group">
                            <label for="t_date">Date <span v-if="totalTodayKeywordsMsg" class="text-danger">{{ totalTodayKeywordsMsg }}</span></label>
                            <input type="text" name="date" id="t_date" v-model="form.date" class="form-control _drp" placeholder="Date">
                        </div>

                        <!-- Keyword Type -->
                        <div class="col-md-2 col-sm-12 form-group">
                            <label for="t_type">Keyword Type</label>
                            <v-select :clearable="false" :clearSearchOnSelect="false" name="type" id="t_type" v-model="form.type" label="title" :reduce="data => data.id" :options="data.typeList" >
                                <template v-slot:option="option">
                                    <span :title="option.title" data-toggle="tooltip" class="text-capitalize">{{ option.title }}</span>
                                </template>
                            </v-select>
                        </div>

                        <!--Country -->
                        <div class="col-md-4 col-sm-12 form-group" v-if="! setting.isFree">
                            <label for="t_country">Country</label>
                            <v-select
                                :multiple="true" :clearable="false" :clearSearchOnSelect="false"
                                name="country" id="t_country" v-model="form.country" label="name"
                                :reduce="data => data.code" :options="data.countries" title="Country"
                                @input="countrySelected"
                            >
                                <template v-slot:option="option">
                                    <span class="text-capitalize">{{ option.name }}</span>
                                </template>
                                <template #selected-option="option">
                                    <span class="text-capitalize">{{ option.name }}</span>
                                </template>
                            </v-select>
                        </div>

                        <!-- Category -->
                        <div class="col-md-3 col-sm-12 form-group" v-if="! setting.isFree">
                            <label for="t_category">Category</label>
                            <v-select :clearable="false" :clearSearchOnSelect="false" @input="filterByCategory" name="category" id="t_category" v-model="form.category" label="title" :reduce="data => data.id" :options="data.categories" >
                                <template v-slot:option="option">
                                    <span :title="option.en_title" data-toggle="tooltip" class="text-capitalize">{{ option.title }}</span>
                                </template>
                            </v-select>
                        </div>

                        <!-- keyword -->
                        <div :class="['col-sm-12 form-group', (setting.isFree ? 'col-md-7' : 'col-md-9')]">
                            <label for="t_keyword">Keywords</label>
                            <a href="javascript:void(0);" class="text-danger" style="float: right;" @click="deSelectKeywordSelect" v-if="form.keyword.length > 0">Clear</a>
                            <div class="input-group">
                                <div class="input-group-btn">
                                    <button type="button" class="btn btn-default dropdown-toggle textLightBlack textTitleCase lh40" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{ keywordSearchTypeTitle  }} <span class="caret"></span>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li><a href="javascript:void(0);" @click="form.keyword_stype = 'phrasal'">
                                            <i class="fa fa-check" v-if="form.keyword_stype == 'phrasal'"></i> Phrasal
                                        </a></li>
                                        <li><a href="javascript:void(0);" @click="form.keyword_stype = 'exact'">
                                            <i class="fa fa-check" v-if="form.keyword_stype == 'exact'"></i> Exact
                                        </a></li>
                                        <li><a href="javascript:void(0);" @click="form.keyword_stype = 'negative'">
                                            <i class="fa fa-check" v-if="form.keyword_stype == 'negative'"></i> Negative
                                        </a></li>
                                    </ul>
                                </div><!-- /btn-group -->
                                <v-select :taggable="true" :multiple="true" @option:created="phrasalKeywordNewTagCreated" :closeOnSelect="false"
                                          name="keyword" id="t_keyword" v-model="form.keyword" :options="[]"
                                          title="Keywords" placeholder="Search by Keywords / Use comma separated keywords for bulk addition" />
                            </div>
                        </div>

                        <div class="col-md-3 col-sm-12 form-group">
                            <label for="t_climit">Character Limit</label>
                            <v-select :clearable="false" :clearSearchOnSelect="true" name="climit" id="t_climit" v-model="form.climit" label="title" :reduce="data => data.id" :options="data.characterLimitList" >
                                <template v-slot:option="option">
                                    <span :title="option.title" data-toggle="tooltip" class="text-capitalize">{{ option.title }}</span>
                                </template>
                            </v-select>
                        </div>

                        <!-- Filters -->
                        <template v-if="setting.isAuthenticated">
                            <div class="col-md-3 col-sm-12 form-group" v-if="data.keywordFilters.length > 0">
                                <label for="t_filter">Filters</label>
                                <select name="t_filter" id="t_filter" class="form-control" @change="selectFilters">
                                    <option value="">Select Filter</option>
                                    <option :value="v.id" v-for="v in data.keywordFilters">{{ $_f.initCap(v.name) }} </option>
                                </select>
                                <!--                <v-select :clearable="false" :clearSearchOnSelect="false" name="filter" id="t_filter" label="name" :reduce="data => data.id" :options="data.keywordFilters" title="Filters" />-->
                            </div>
                            <div class="col-md-3 col-sm-12 form-group" v-else>
                                <a :href="routeFilter" class="btn btn-block bg-primary-dark mt25"><i class="fa fa-save"></i> Save Filter</a>
                            </div>
                        </template>

                        <!-- Custom Niche -->
                        <!--                <div class="col-md-3 col-sm-12 form-group" v-if="! setting.isFree">
                                            <label for="t_mykeyword">Custom Niche</label>
                                            <v-select :disabled="! setting.isCustomKeywordAllowed" :title="setting.isCustomKeywordAllowed ? 'Custom Niche' : 'Buy Custom Niche'" :clearable="false" :clearSearchOnSelect="false" name="mykeyword" id="t_mykeyword" v-model="form.mykeyword" label="name" :reduce="data => data.id" :options="data.orders" />
                                        </div>-->

                        <!-- Sort By -->
                        <div class="col-md-3 col-sm-12 form-group">
                            <label for="t_sort_by">Sort By</label>
                            <v-select :clearable="false" :clearSearchOnSelect="false" name="sort_by" id="t_sort_by" v-model="form.sortby" label="title" :reduce="data => data.id" :options="sortOptions" title="Sort By" />
                        </div>

                        <!-- Country Tiers -->
<!--                        <div class="form-group col-md-3" v-if="! setting.isFree">
                            <label class="">Country Tiers</label><br>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="tier" id="t_tier_all" v-model="form.tier" value="-1" class="custom-control-input"  >
                                <label class="custom-control-label" for="t_tier_all"> All</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline"  v-for="(v,i) in data.tiers">
                                <input type="radio" name="tier" :id="'t_tier_'+i" v-model="form.tier" :value="v.value" class="custom-control-input">
                                <label class=" custom-control-label"  :for="'t_tier_'+i" data-toggle="tooltip" :title="countryGroupTitle(v.value)"> {{ $_f.initCap(v.name) }}</label>
                            </div>
                        </div>-->

                        <div class="form-group col-md-12" v-if="tagList.length > 0">
                            <label class="">Sub Category:</label>
                            <div class="custom-control custom-radio custom-control-inline" v-for="(v,i) in tagList">
                                <input type="checkbox" name="tags[]" :id="'t_tags_'+i" v-model="form.tags" :value="v.trim()" class="custom-control-input"  >
                                <label class="custom-control-label" :for="'t_tags_'+i"> {{ v }}</label>
                            </div>
                        </div>

                    </div>


                    <div class="row">
                        <div class="col-md-12 form-group text-right" >
                            <button type="button" class="btn btn-red btn-small btn-effect mr5" :disabled="loading" @click="resetFilter"><i class="fa fa-times"></i> reset</button>
                            <button type="submit" class="btn bg-primary-dark btn-small btn-effect" :disabled="loading"><i class="fa fa-search"></i> search</button>
                        </div>
                    </div>

                </form>
            </div>
        </div>


        <Keywords @gwCount="fetchGoogleWebCount"
                  @paginate="fetchRecord"
                  :isGwCount="true"
                  :isGwCountExceeded="gwCountExceeded"
                  :keywords="keywordList"
                  :is-authenticated="setting.isAuthenticated"
                  :is-free="setting.isFree"
                  :download="true"
                  @download="showExport"

        />


        <div class="cd-user-modal" id="downloadModal">
            <!-- this is the entire modal form, including the background -->
            <div class="cd-user-modal-container">
                <div id="downloadBox" class="is-selected">
                    <!-- log in form -->
                    <form class="cd-form" @submit.prevent="download">
                        <p class="fieldset">
                            <label class="" for="exp-ext">File Type</label>
                            <select class="form-control full-width has-padding has-border" name="exp-ext" id="exp-ext" v-model="exportForm.extension" title="Extension">
                                <option value="csv">CSV</option>
                                <option value="txt">Text</option>
                            </select>
                        </p>
                        <p class="fieldset">
                            <label class="" for="exp-volume">Show Trend Column</label>
                            <select class="form-control full-width has-padding has-border" name="exp-volume" id="exp-volume" v-model="exportForm.volume" title="Show Trend Column">
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </p>

                        <p class="fieldset">
                            <label class="" for="exp-volume">Show Google Searches Column</label>
                            <select class="form-control full-width has-padding has-border" name="exp-searches" id="exp-volume" v-model="exportForm.searches" title="Show Google Searches Column">
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </p>

                        <p class="fieldset">
                            <label class="" for="exp-rpp">How Many Rows?</label>
                            <select class="form-control full-width has-padding has-border" name="exp-rpp" id="exp-rpp" v-model="exportForm.rpp" title="Show Trend Column">
                                <option :value="v.value" v-for="v in exportForm.rppType">{{ v.title }}</option>
                            </select>
                        </p>

                        <div class="btn-group" role="group">
                            <button type="button" value="Login" class="btn btn-danger bg-red" @click="clearExport">Close</button>
                            <button type="submit" value="Login" class="btn btn-info bg-blue">Download</button>
                        </div>


                    </form>
                </div>
            </div>
            <!-- cd-user-modal-container -->
        </div>


    </div>

</template>

<script>
    import Pagination from "../shared/components/Pagination.vue";
    import {datetimeMixin} from "../shared/mixins/datetime.mixin.js";
    import Loader from "../shared/components/Loader.vue";
    import Keywords from "../components/Keywords.vue";
    import { isMobile } from "@/shared/helper.js";
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        name: "Topics",
        components:{
            Keywords,
            "paginate": Pagination,
            "loader": Loader,
            "v-select" : vSelect,
        },
        mixins:[datetimeMixin],
        props:['keywords'],
        computed:{
            negativeCountryList() {
                return this.data.countries.filter((c) => {

                    if(c.code == '-1')
                    {
                        return false;
                    }
                    else if(this.form.country.includes(c.code))
                    {
                        return false;
                    }
                    return true;
                });
            },
            keywordSearchTypeTitle() {
                let title = 'Phrasal';

                if(this.form.keyword_stype == 'exact')
                {
                    title =  'Exact';
                }
                else if(this.form.keyword_stype == 'negative')
                {
                    title = 'Negative';
                }
                return title;
            }
        },
        created() {
            this.keywordList = this.keywords;

            this.makeExportRppList();

            if(this.setting.isFree)
            {
                this.sortOptions = [
                    {id: 'ratingAsc' , 'title': 'Trend (Low to High)'},
                    {id: 'ratingDesc' , 'title': 'Trend (High to Low)'},
                ];
            }
            else
            {
                this.sortOptions = [
                    {id: 'ratingAsc' , 'title': 'Trend (Low to High)'},
                    {id: 'ratingDesc' , 'title': 'Trend (High to Low)'},
                    //{id: 'compAsc' , 'title': 'Competition (Low to High)'},
                    //{id: 'compDesc' , 'title': 'Competition (High to Low)'},
                    //{id: 'volAsc' , 'title': 'Volume (Low to High)'},
                    //{id: 'volDesc' , 'title': 'Volume (High to Low)'},
                    {id: 'gwAsc' , 'title': 'Google Search (Low to High)'},
                    {id: 'gwDesc' , 'title': 'Google Search (High to Low)'},
                ]
            }

        },
        mounted(){
            this.setupDatePicker();

            this.filterByCategory(this.form.category, false);

        },
        data() {
            return {
                showFilter: !isMobile(),
                loading:false,
                gwCountExceeded : false,
                filter:'',
                data: window.__st.data,
                keywordList: {},
                totalTodayKeywordsMsg: window.__st.totalTodayKeywordsMsg || '',
                form: {
                    date:     window.__st.data.f.date  || moment().format("YYYY-MM-DD") + ' / ' + moment().format("YYYY-MM-DD"),
                    keyword:  window.__st.data.f.keyword || [],
                    keyword_stype:  window.__st.data.f.keyword_stype || 'exact',
                    type: window.__st.data.f.type  || 'new',
                    language: window.__st.data.f.language  || '-1',
                    country:  window.__st.data.f.country  ||  ['-1'],
                    country_negative:  window.__st.data.f.country_negative  ||  [],
                    category: window.__st.data.f.category  || '-1',
                    tags: window.__st.data.f.tags  || [],
                    tier:     window.__st.data.f.tier  ||     '-1',
                    sortby:   window.__st.data.f.sortby || 'ratingDesc',
                    mykeyword: window.__st.data.f.mykeyword || '-1',
                    climit: window.__st.data.f.climit || '-1',
                },
                keywordOptions: window.__st.data.f.keyword || [],
                sortOptions: [],
                tagList: [],
                exportForm:{
                    extension: 'csv',
                    volume: 1,
                    searches: 1,
                    rppType: [],
                    rpp: "current",
                },
                setting: window.__st.setting,
                routeFilter: window.__st.routes.filter,
            }
        },
        methods:{

            fetchRecord(page=1) {

                if( !this.setting.isAuthenticated)
                {
                    return false;
                }

                this.scrollToTop();

                this.loading = true;
                blockUI("keywordList", "#")

                axios.post(window.__st.routes.keyword+`?page=${page}`, this.form).then((res) => {
                    this.keywordList = res.data.data;
                }).catch((err) => {
                    toaster("error happen " + err.response.status, "error");
                }).finally(() => {
                    this.loading = false;
                    unBlockUI("keywordList", "#")
                });

            },

            resetFilter() {

                this.form = {
                    date:moment().format("YYYY-MM-DD") + ' / ' + moment().format("YYYY-MM-DD"),
                    type: 'duplicate',
                    keyword: [],
                    keyword_stype: 'exact',
                    language: '-1',
                    country: ['-1'],
                    country_negative: [],
                    category: this.setting.isFree ? (window.__st.data.f.category  || '-1') : '-1',
                    tags: [],
                    tier:'-1',
                    sortby: 'ratingDesc',
                    mykeyword: '-1',
                    climit: '-1',
                };
                this.keywordOptions = [];
            },

            countryGroupTitle(countryCodes)
            {
               return countryCodes.split(",").map((country)=> {
                   return window.__st.data.country_groups[country.toLowerCase()];
               }).join(", ");
            },

            setupDatePicker() {
                var vm = this;
                var dp = $('._drp').daterangepicker({
                    locale: {
                        format: 'YYYY-MM-DD',
                        cancelLabel: 'Clear'
                    },
                    autoclose: true,
                    clearBtn: true,
                    autoUpdateInput: false,
                    maxDate: vm.setting.startDate,
                    minDate: vm.setting.endDate,
                });
                dp.on('cancel.daterangepicker', function(ev, picker) {
                    //do something, like clearing an input
                    $('._drp').val('');
                    vm.form.date = '';
                });
                dp.on('apply.daterangepicker', function(ev, picker) {
                    vm.form.date = picker.startDate.format('YYYY-MM-DD') + ' / ' + picker.endDate.format('YYYY-MM-DD');
                });


                $(".cancelBtn").addClass("btn btn-small btn-danger");
                $(".applyBtn").addClass("btn btn-small btn-primary");
            },

            filterByCategory(categoryId, emptyTags = true){

                this.tagList = [];
                if(emptyTags)
                {
                    this.form.tags = [];
                }


                if(categoryId == "-1")
                {
                    return;
                }

                let category = this.data.categories.find((cat) => cat.id == categoryId);

                if (category)
                {
                    if(category.tags)
                    {
                        let tags = category.tags.split(",");
                        this.tagList = tags;
                    }
                    else
                    {
                        this.tagList = [];
                    }

                }
                else
                {
                    this.tagList = [];
                }

            },

            deSelectKeywordSelect(){
                this.form.keyword = [];
            },

            deSelectNegativeKeywordSelect(){
                this.form.negative_keyword = [];
            },

            deSelectPhrasalKeywordSelect(){
                this.form.phrasal_keyword = [];
            },

            fetchCategoryByLanguage(option) {
                this.loading = true;

                this.form.category = "-1";
                axios.post(window.__st.routes.categoryByLanguage, { language: option }).then((res) => {
                    this.data.categories = res.data.data;
                }).catch((err) => {
                    toaster("error happen " + err.response.statusCode , "error");
                }).finally(() => {
                    this.loading = false;
                });
            },

            fetchGoogleWebCount(index, id, keyword){
                this.loading = true;
                blockUI("keywordList", "#")
                let params = {
                    "id" : id,
                    "keyword": keyword
                };
                this.keywordList.data[index].pw_count = null;
                axios.post(window.__st.routes.googleWebCount, params).then((res) => {
                    this.keywordList.data[index].gw_count = res.data.total;
                    this.keywordList.data[index].volume = res.data.volume;
                    this.keywordList.data[index].competition = res.data.competition;
                }).catch((err) => {
                    if(err.response.status == 403)
                    {
                        toaster(err.response.data.message, "error");
                        this.gwCountExceeded = true;
                    }
                    else
                    {
                        toaster("error happen " + err.response.status , "error");
                    }
                }).finally(() => {
                    this.loading = false;
                    unBlockUI("keywordList", "#")
                });
            },

            scrollToTop() {
                document.getElementById('keywordList').scrollIntoView();
                document.getElementById('keywordList').scrollTop = 0;
                document.getElementById('keywordTableResponsive').scrollTop = 0;
            },

            showExport(){
                this.clearExport();
                $("#downloadModal").addClass("is-visible");
            },

            clearExport() {

                $("#downloadModal").removeClass("is-visible");

                this.exportForm = {
                    extension: 'csv',
                    volume: 1,
                    searches: 1,
                    rppType: [],
                    rpp: "current",
                };
                this.makeExportRppList();
            },

            makeExportRppList() {
                this.exportForm.rppType = [
                    {value: "all", title: "All " + this.keywordList?.total || 0} ,
                    {value: "current", title: "Current Page: " +  this.keywordList?.per_page } ,
                ];
            },

            keywordNewTagCreated(option) {
                var that  = this;
                setTimeout(function (){
                    let options = option.split(",");

                    if(options.length > 1)
                    {
                        let newOptions = that.form.keyword.concat(options);
                        that.form.keyword = [];
                        let insertOptions = [];
                        newOptions.forEach(opt => {
                            if(opt != option)
                            {
                                insertOptions.push(opt);
                            }
                        })
                        that.form.keyword =    [...new Set(insertOptions)]
                    }
                }, 50)
            },

            negativeKeywordNewTagCreated(option) {
                var that  = this;
                setTimeout(function (){
                    let options = option.split(",");

                    if(options.length > 1)
                    {
                        let newOptions = that.form.negative_keyword.concat(options);
                        that.form.negative_keyword = [];
                        let insertOptions = [];
                        newOptions.forEach(opt => {
                            if(opt != option)
                            {
                                insertOptions.push(opt);
                            }
                        })
                        that.form.negative_keyword =    [...new Set(insertOptions)]
                    }
                }, 50)
            },

            phrasalKeywordNewTagCreated(option) {
                var that  = this;
                setTimeout(function (){
                    let options = option.split(",");

                    if(options.length > 1)
                    {
                        let newOptions = that.form.phrasal_keyword.concat(options);
                        that.form.phrasal_keyword = [];
                        let insertOptions = [];
                        newOptions.forEach(opt => {
                            if(opt != option)
                            {
                                insertOptions.push(opt);
                            }
                        })
                        that.form.phrasal_keyword =    [...new Set(insertOptions)]
                    }
                }, 50)
            },


            selectFilters(e)
            {
                let filterid = e.target.value;

                if(! filterid)
                {
                    return true;
                }

                let filter = this.data.keywordFilters.find((f) => f.id == filterid);

                if(! filter) {
                    return true;
                }

                this.form.country = filter.payload["country"] || [];
                this.form.country_negative = filter.payload["country_negative"] || [];
                this.form.keyword = filter.payload["keyword"] || [] ;
                //this.form.negative_keyword = filter.payload["keyword_negative"] || [] ;
                //this.form.phrasal_keyword = filter.payload["phrasal_keyword"] || [] ;
                this.form.tier = filter.payload["tier"] || "-1" ;
                this.form.sortby = filter.payload["sortby"] || "ratingDesc" ;
                this.form.climit = filter.payload["climit"] || "-1" ;
            },

            countrySelected(values) {

                let lastValue = values[values.length - 1];
                if(lastValue == '-1')
                {
                    this.form.country = [lastValue];
                }
                else
                {
                    if(values.length > 1)
                    {
                        this.form.country = this.form.country.filter((f) => f != '-1');
                    }

                    if(values.length == 0)
                    {
                        this.form.country = ['-1'];
                    }

                    if(! this.form.country.includes("-1"))
                    {
                        this.form.country_negative = [];
                    }
                }

            },

            download() {

                let params = Object.assign({} ,this.form);

                let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
                queryString += "&"+"volume="+this.exportForm.volume + "&"+"searches="+this.exportForm.searches + "&extension="+this.exportForm.extension;

                queryString += "&page="+this.keywordList.current_page+"&rppType="+this.exportForm.rpp;
                let url = window.__st.routes.keywordDownload + "?"+queryString;
                window.open(url, "_blank");

                this.clearExport();
            },
        },

    }
</script>

<style>
    .vs__dropdown-toggle{
        min-height: 42px;
        font-size:15px !important;
        background-color:#fff !important;
    }

    .custom-control {
        min-height: auto;
    }
    .custom-control-inline {
        display: inline-flex;
        margin-right: 1rem;
    }

    .custom-control-label
    {
        margin-left: 0.5rem;
    }
</style>
<style scoped>
    .table.table-sm td, .table.table-sm th {
        vertical-align: middle;
    }
    .textTitleCase{
        text-transform: capitalize;
    }
    .lh40 {
        line-height: 40px;
    }
    .textLightBlack {
        color: #333 !important;
    }
</style>



<!-- Negative Country -->
<!--                        <div class="col-md-3 col-sm-12 form-group" v-if="! setting.isFree">
                            <label for="t_neg_country">Negative Country</label>
                            <v-select
                                :multiple="true"
                                :clearable="false"
                                :clearSearchOnSelect="false"
                                name="country" id="t_neg_country"
                                v-model="form.country_negative" label="name"
                                :reduce="data => data.code" :options="negativeCountryList"
                                title="Country"
                                placeholder="Select Negative Country"
                            >
                                <template v-slot:option="option">
                                    <span class="text-capitalize">{{ option.name }}</span>
                                </template>
                            </v-select>
                        </div>-->
<!--      <div class="row">

    <div :class="['form-group col-12 col-md-5']">
        <label for="t_keyword">Exact Keywords</label>
        <v-select :taggable="true" :multiple="true" @option:created="keywordNewTagCreated" :closeOnSelect="false"
                  name="keyword" id="t_keyword" v-model="form.keyword" :options="keywordOptions"
                  title="Keywords" placeholder="Search by Exact Keywords / Use comma separated keywords for bulk addition" />
        <a href="javascript:void(0);" class="text-danger" @click="deSelectKeywordSelect" v-if="form.keyword.length > 0">Clear</a>
    </div>

    &lt;!&ndash; Negative Keywords &ndash;&gt;
    <div class="form-group col-sm-12 col-md-5">
        <label for="t_negative_keyword">Negative Keywords</label>
        <v-select :taggable="true" :multiple="true"
                  name="negative_keyword" id="t_negative_keyword" v-model="form.negative_keyword" :options="[]"  @option:created="negativeKeywordNewTagCreated" :closeOnSelect="false"
                  title="Negative Keywords" placeholder="Ignore Negative Keywords  / Use comma separated keywords for bulk addition" />
        <a href="javascript:void(0);" class="text-danger" @click="deSelectNegativeKeywordSelect" v-if="form.negative_keyword.length > 0">Clear</a>
    </div>

</div>-->
<!-- Phrasal Keywords -->
<!--                        <div :class="['form-group col-sm-12', (setting.isFree ? 'col-md-7' : 'col-md-9')]">
                            <label for="t_phrasal_keyword">Phrasal Keywords</label>
                            <v-select :taggable="true" :multiple="true" @option:created="phrasalKeywordNewTagCreated" :closeOnSelect="false"
                                      name="phrasal_keyword" id="t_phrasal_keyword" v-model="form.phrasal_keyword" :options="[]"
                                      title="Phrasal Keywords" placeholder="Search by Phrasal Keywords / Use comma separated keywords for bulk addition" />
                            <a href="javascript:void(0);" class="text-danger" @click="deSelectPhrasalKeywordSelect" v-if="form.phrasal_keyword.length > 0">Clear</a>
                        </div>-->
